(() => {
  const init = root => {
    root.querySelectorAll('[data-supplier-directory]').forEach(directory => {
      if (directory.dataset.ready) return;
      directory.dataset.ready = 'true';
      const input = directory.querySelector('[data-supplier-search]');
      const rows = [...directory.querySelectorAll('[data-supplier-name]')];
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      input.addEventListener('input', () => {
        const query = normalize(input.value.trim());
        let visible = 0;
        rows.forEach(row => { row.hidden = !normalize(row.dataset.supplierName).includes(query); if (!row.hidden) visible++; });
        directory.querySelector('[data-supplier-empty]').hidden = visible > 0;
      });
    });
    root.querySelectorAll('[data-help-signin]').forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('return_to', location.pathname + location.search + '#supplier-orders');
      link.href = url.href;
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
